import React from 'react';
import styled from 'styled-components';
import {useBoundStore} from "../../stores/useBoundStore";
import {colorSchemeThemes} from "../../utils/styling";

const Holder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;
  width: 100%;

  button {
    border: 1px dotted transparent;
    padding: 0.5rem;

    &.active {
      border-color: var(--color-1);
    }
  }

  .custom-scheme {
    padding: 0.5rem;
    margin: 0;
    border: 1px dotted;
    ${props => props.theme.fluidType(-2)};
    text-align: center;
    aspect-ratio: 1/1;
    display: flex;
    align-items: center;
  }
`;

const Inner = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 2px;

  .circle {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    border-radius: 50%;
    background-color: var(--color);
  }
`;

function ColorSchemePicker() {
  const colorScheme = useBoundStore(state => state.colorScheme);
  const setColorScheme = useBoundStore(state => state.setColorScheme);

  return (
    <Holder>
      {colorSchemeThemes.map((scheme, index) => {
          const colors = Object.keys(scheme.colors);
          return (
            <button key={index} className={colorScheme === index ? 'active' : ''} onClick={() => setColorScheme(index)}>
              <Inner>
                {colors.map((keyName, i) => (
                  <div key={i} className="circle" style={{'--color': scheme.colors[keyName]}} />
                ))}
              </Inner>
            </button>
          )
        }
      )}
      <p className="custom-scheme">Set your own scheme.<br/>Coming soon.</p>
    </Holder>
  )
}

export default ColorSchemePicker;